import * as React from 'react';
import { Link } from '@tanstack/react-router';
import { Button } from '@/components/ui/button';

export function NotFoundPage() {
  React.useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);
  return (
    <main className="mx-auto flex min-h-[70vh] max-w-xl flex-col items-center justify-center px-5 text-center">
      <h1 className="font-heading text-4xl font-semibold">That stop isn’t on this map.</h1>
      <p className="mt-4 text-muted-foreground">The page you’re looking for doesn’t exist in Seattle Bus Times.</p>
      <Link to="/" className="mt-7">
        <Button>Return to arrivals</Button>
      </Link>
    </main>
  );
}
